import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import BASE_URL from '../../../config/config';
import { Link } from 'react-router-dom';
import { FiCode, FiPenTool, FiTrendingUp, FiFolder, FiCheckCircle, FiClock, FiFolderPlus, FiAlertTriangle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import Loader from '../../../components/Loader';
import { claves } from '../../../queries/cliente';

const ICONO_TIPO = { diseno: FiPenTool, marketing: FiTrendingUp, desarrollo: FiCode };

const UserProyectos = () => {
  const { t } = useTranslation();

  const token = localStorage.getItem("AuthToken");
  let tokenInfo = {};
  if (token) {
    tokenInfo = jwtDecode(token);
  }

  const consultaProyectos = useQuery({
    queryKey: claves.proyectosUsuario(tokenInfo.usuario),
    queryFn: async () => {
      try {
        const resp = await axios.get(`${BASE_URL}/proyectos/usuario/${tokenInfo.usuario}`);
        return resp.data?.proyectos || [];
      } catch (err) {
        // El backend devuelve 404 cuando el usuario simplemente no tiene
        // proyectos: no es un error real, es una lista vacía.
        if (err.response?.status === 404) return [];
        throw err;
      }
    },
    enabled: Boolean(tokenInfo.usuario),
  });

  const proyectos = consultaProyectos.data || [];
  const isLoading = consultaProyectos.isPending;
  const error = consultaProyectos.isError ? t('proyectos.errorCargarLista') : '';

  if (isLoading) return <div className="loader-fullscreen"><Loader /></div>;

  return (
    <main className='site-width'>
      <div className="user-proyectos">
        <div className="pagina-cabecera">
          <h2>{t('proyectos.misProyectos')}</h2>
          <p>{t('proyectos.subtitulo')}</p>
        </div>

        {error ? (
          <div className="proy-estado-card proy-estado-card--error">
            <FiAlertTriangle />
            <p>{error}</p>
          </div>
        ) : proyectos.length > 0 ? (
          <div className='grid-user-proyectos'>
            {proyectos.map(proyecto => {
              const TipoIcon = ICONO_TIPO[proyecto.tipo_de_proyecto] || FiFolder;
              const tipoLabel = t(`tipoProyecto.${proyecto.tipo_de_proyecto}`, { defaultValue: t('tipoProyecto.no_especificado') });
              // La comprobación final llega a "aceptado" cuando el proyecto queda validado y cerrado.
              const terminado = proyecto.comprobacion_final === 'aceptado';
              return (
                <Link className='item-user-proyectos' to={`/dashboard/proyecto/${proyecto.id}`} key={proyecto.id}>
                  <div className="proy-card-icon"><TipoIcon /></div>
                  <div className="proy-card-body">
                    <h3>{proyecto.nombre}</h3>
                    <span className="proy-card-tipo">{tipoLabel}</span>
                  </div>
                  <span className={`proy-card-badge ${terminado ? 'terminado' : 'progreso'}`}>
                    {terminado ? <FiCheckCircle /> : <FiClock />}
                    {terminado ? t('proyectos.terminado') : t('proyectos.enProgreso')}
                  </span>
                </Link>
              );
            })}
          </div>
        ) : (
          <div className="proy-estado-card">
            <FiFolderPlus />
            <p>{t('proyectos.sinProyectos')}</p>
            <span>{t('proyectos.sinProyectosNota')}</span>
          </div>
        )}
      </div>
    </main>
  );
};

export default UserProyectos;
